<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      ref="tabs"
      v-model="search.year"
      pills
      class="mb-4"
      @input="getReportMonthMember()"
    >
      <b-tab
        v-for="(item, index) in options.year"
        :key="index"
        :title="item.label"
      />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    >
      <template v-for="field in periods" v-slot:[getSlotName(field)]="row">
        <span
          :key="field"
          :class="{'link': row.item[field].isOpenContractModal}"
          @click="row.item[field].isOpenContractModal ? openContractModal(row.item[field]) : null"
        >
          {{ row.item[field].value }}
        </span>
      </template>
    </tables-page>

    <member-monthly-count-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data"
    />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import MemberMonthlyCountContractModal from "./components/modal/MemberMonthlyCountContractModal";

export default {
  name: 'monthlyCount',
  components: {
    BreadCrumb,
    TablesPage,
    MemberMonthlyCountContractModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '每月件數', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false
      },
      options: {
        year: [],
      },
      search: {
        year: 0
      },
      data: {
        table_data: [],
        table_fields: [
            { key: "type", label: "類別" },
            { key: "month_1", label: "一月" },
            { key: "month_2", label: "二月" },
            { key: "month_3", label: "三月" },
            { key: "season_1", label: "第一季" },
            { key: "month_4", label: "四月" },
            { key: "month_5", label: "五月" },
            { key: "month_6", label: "六月" },
            { key: "season_2", label: "第二季" },
            { key: "month_7", label: "七月" },
            { key: "month_8", label: "八月" },
            { key: "month_9", label: "九月" },
            { key: "season_3", label: "第三季" },
            { key: "month_10", label: "十月" },
            { key: "month_11", label: "十一月" },
            { key: "month_12", label: "十二月" },
            { key: "season_4", label: "第四季" },
            { key: "total", label: "合計" },
        ],
        temp_table_data: {}
      },
      // 定義欄位順序，對應 table_fields 的 key
      periods: [
        'month_1', 'month_2', 'month_3', 'season_1',
        'month_4', 'month_5', 'month_6', 'season_2',
        'month_7', 'month_8', 'month_9', 'season_3',
        'month_10', 'month_11', 'month_12', 'season_4',
        'total'
      ]
    }
  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    load() {
      this.generateYearArray();
    },
    getSlotName(field) {
        return `cell(${field})`;
    },
    generateYearArray() {
      const currentYear = new Date().getFullYear();
      const startYearROC = 105;
      const endYearROC = currentYear - 1911;

      const yearArray = Array.from({ length: currentYear - (startYearROC + 1911) + 1}, (num, index) => {
        const rocYear = endYearROC - index;
        const adYear = currentYear - index;
        return { value: index, label: `${rocYear}年`, key: adYear };
      });

      this.options.year = yearArray;
      this.getReportMonthMember();
    },
    getReportMonthMember() {
      const year = this.options.year.find(item => item.value === this.search.year).key;
      const params = { year: year };

      this.reportApi.getReportMonthMember((response) => {
        const resData = (response.data && response.data.data && response.data.data[0]) ? response.data.data[0] : {};
        this.tableFormatHandler(resData, year)
      }, params)
    },

    /**
     * 1. 計算 Total (sum of month 1~12)
     * 2. 準備 Total 點擊後需要的 "整年明細"
     */
    tableFormatHandler(apiData, currentYear) {
      // 定義三個類別的 Key 與顯示名稱
      const categoryMap = {
        add: '新增件',
        dead: '身故件',
        exclusion: '失效件'
      };

      const formattedRows = [];

      // 針對每一個類別 (add, dead, exclusion) 跑迴圈
      Object.keys(categoryMap).forEach(typeKey => {
        const typeLabel = categoryMap[typeKey];

        // --- 步驟 1: 先計算該類別的「合計」並收集「12個月明細」 ---
        let calcTotal = 0;
        let yearlyDetails = []; // 用來存 1~12 月的數據，給 Modal 用

        for (let i = 1; i <= 12; i++) {
          const key = `month_${i}_${typeKey}`;
          const val = apiData[key] || 0;

          calcTotal += val;
          yearlyDetails.push({
             month: i,
             value: val,
             // 為了 Modal 顯示方便，也可以把其他資訊塞進去
             label: `${i}月`
          });
        }

        // --- 步驟 2: 建立這一列 (Row) 的資料物件 ---
        // 先建立基本物件，包含第一欄 'type'
        let rowObj = { type: typeLabel };

        // 接著跑 columns (periods) 填入對應的資料格
        this.periods.forEach(period => {
          let cellValue = 0;
          let isTotalColumn = (period === 'total');
          let periodKeyForApi = `${period}_${typeKey}`; // 例如 season_1_add

          // 判斷取值邏輯
          if (isTotalColumn) {
            // 如果是合計欄位，使用我們剛才算好的 calcTotal
            cellValue = calcTotal;
          } else {
            // 如果是月份或季度，直接從 API 資料拿
            cellValue = apiData[periodKeyForApi] || 0;
          }

          // 建立該格子的資料結構 (傳給 Modal 用的整包物件)
          rowObj[period] = {
            value: cellValue,
            rowType: typeKey,       // add, dead, exclusion
            periodKey: period,      // month_1, season_1, total
            year: currentYear,
            label: typeLabel,       // 標題名稱
            isOpenContractModal: cellValue > 0, // 數值 > 0 才可點擊

            // **關鍵修改**:
            // 如果是 Total 欄位，我們多傳入一個 `monthlyData` 陣列
            // 這樣 Modal 接收到 data 後，就可以判斷如果有這個欄位，就顯示列表
            monthlyData: isTotalColumn ? yearlyDetails : null
          };
        });

        formattedRows.push(rowObj);
      });

      this.data.table_data = formattedRows;
    },

    // 開啟契約 modal
    openContractModal(item) {
      this.status.contractModal = true;
      // 使用 Object.assign 避免汙染原始資料，傳入 item
      // item 裡面現在包含了 monthlyData (如果是點擊合計的話)
      this.data.temp_table_data = Object.assign({}, item);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Backstage/yf/monthlyCount.vue